export function exhaustCheck(option: never): never {
  throw new Error(`Reaching an impossible state because of ${option}`);
}
